import { default as Range, RangeDates } from './Range';
import { default as Single, SingleDates } from './Single';

/** @component */
export default { Range, Single };

export type { RangeDates, SingleDates };
